// extracted by mini-css-extract-plugin
export default {"background":"NGUac","item":"SDTmO","border":"LGMg2","skeleton":"or80R","checkMark":"DGMYB"};